import { PersonDetailsWrite } from 'src/app/people/models/personDetailsWrite';
import { AttributesEditorDataSource } from '../../components/attributes-editor/attributesEditorDataSource';
import { PaymentResult, PaymentType } from './paymentOptions';
import { Image } from 'src/app/people/models/image';
import { AttributeWrite } from '../attributes/attributeWrite';
import { ComplexAttributeWrite } from '../attributes/complexAttributeWrite';

export interface IApplicationSubmit {
  personId: string;
  person: PersonDetailsWrite;
  image: { imageId: string };
  attributes: AttributeWrite[];
  complexAttributes: ComplexAttributeWrite[][];
  payment: {
    paymentIntentId: string;
    paymentMethodType: PaymentType;
  };
}
export interface IPaymentPreview extends Omit<IApplicationSubmit, 'image' | 'payment'> {}

export const buildApplicationSubmit = (
  person: PersonDetailsWrite,
  attributesEditorDataSource: AttributesEditorDataSource,
  personId: string,
  stripeResult: PaymentResult,
  image: Image
): IApplicationSubmit => {
  return {
    ...buildPaymentPreview(person, attributesEditorDataSource, personId),
    payment: {
      paymentIntentId: stripeResult?.paymentIntentId,
      paymentMethodType: stripeResult?.paymentType,
    },
    image: image?.id ? { imageId: image.id } : null,
  };
};

export const buildPaymentPreview = (
  person: PersonDetailsWrite,
  attributesEditorDataSource: AttributesEditorDataSource,
  personId: string
): IPaymentPreview => {
  const { attributes, complexAttributes } = attributesEditorDataSource.getWriteAttributes();

  return {
    person: person,
    attributes: attributes,
    complexAttributes: complexAttributes,
    personId: personId,
  };
};
